import { render, staticRenderFns } from "./pass-info.vue?vue&type=template&id=1528176c&scoped=true&"
import script from "./pass-info.vue?vue&type=script&lang=ts&"
export * from "./pass-info.vue?vue&type=script&lang=ts&"
import style0 from "./pass-info.vue?vue&type=style&index=0&id=1528176c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1528176c",
  null
  
)

export default component.exports